import { store } from "../store/store";
import { API_BASE_URL } from "./config";
import {Navigate} from "react-router";
import React from "react";
import {logout} from "../slices/authSlice";

// Hàm lấy token từ Redux state
const getAuthToken = (): string => {
  return store.getState().auth.token ?? "";
};

// Hàm gọi API chung
export const apiRequest = async (
  endpoint: string,
  method: string = "GET",
  token?: string,
  body?: any
) => {
  const headers: HeadersInit = {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const options: RequestInit = {
    method,
    headers,
    mode: "cors",
  };

  if (method !== "GET" && method !== "HEAD" && body) {
    if (body instanceof FormData) {
      options.body = body;
    } else {
      headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(body);
    }
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

    if (!response.ok) {
      console.log("API response:", response);
      if (response.status === 401) {
        console.error("Unauthorized! Cần đăng nhập lại.");
      }
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    window.alert("Lỗi khi gọi API: " + (error instanceof Error ? error.message : String(error)));
    console.error("Lỗi khi gọi API:", error);
    throw error;
  }
};

// Hàm gọi API có token (tự động lấy token từ Redux)
export const apiRequestWithAuth = async (
  endpoint: string,
  method: string = "GET",
  body?: any
) => {
  const token = getAuthToken();
  const dispatch = store.dispatch;
  const doRequest = await apiRequest(endpoint, method, token, body);

  if (doRequest.messageCode === 401 || doRequest.messageCode === 410) {
    console.error("Unauthorized! Cần đăng nhập lại.");
    window.alert("Hãy đăng nhập để tiếp tục");
    localStorage.removeItem("token");
    dispatch(logout());
    window.location.href = '/signin';
    throw new Error('Unauthorized');
  }

  return doRequest;
};
